import React from "react";
import { BrowserView } from "react-device-detect";
import { useSelector } from "react-redux";
import { object } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { Button, Carousel } from "../../atoms";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import { useTrackWidgetImpression, getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";
import { HOME_PAGE_RANKING_DESCRIPTIONS } from "../../../../../config/entity-ranking-descriptions";

import "./ranking-entities.m.css";

const RankingEntities = ({ data }) => {
  const deviceType = useDeviceType();
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const networkId = get(qtState, ["config", "ads-config", "network_id"], {});
  const pageType = get(qtState, ["pageType"], "");
  const isAdfreePage = get(qtState, ["config", "subscriber"]) === "true";
  const isBrowser = typeof window !== "undefined";

  // Use the custom hook for tracking widget impressions
  const componentRef = useTrackWidgetImpression(
    {
      sectionName: "Fortune India Rankings",
      pageType: pageType,
      location: isBrowser ? window.location : null,
      config: {},
      threshold: 0.2,
    },
    { disabled: !isBrowser }
  );

  const {
    rankingEntities: { options = [] },
  } = data;

  let isTracking = false;

  const trackEntityClick = (name, position) => {
    if (isTracking) return;
    isTracking = true;

    setTimeout(() => {
      isTracking = false;
    }, 300);

    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      window.dataLayer.push({
        event: "dl_ranking_widget_click",
        link_text: name.toLowerCase(),
        link_position: position,
        link_category: "fortune india rankings",
        category,
        sub_category: subCategory,
        content_id: contentId || "NA",
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const entityCard = (entity, index) => {
    const { name, year, linkTo, svgType, publicsvgType, svgclassName } = entity;

    const handleTrackingEvent = () => {
      trackEntityClick(name, index + 1);
    };

    return (
      <Link href={linkTo} disableAjaxLinks={true} aria-label={name} onMouseDown={handleTrackingEvent} onTouchStart={handleTrackingEvent}>
        <div styleName="card-container" key={index}>
          <div styleName="content">
            <div styleName={`${svgclassName} logo`}>
               <img src={`${publicsvgType}?w=210&auto=format,compress&fit=max&q=70`} alt={name} title={name} loading="lazy" width="135" height="137" />
            </div>
            <div styleName="name">{name}</div>
            <div styleName="year">{year}</div>
            <div styleName="description">{HOME_PAGE_RANKING_DESCRIPTIONS[name]}</div>
          </div>
          <Link href={linkTo} disableAjaxLinks={true}>
            <Button>View List</Button>
          </Link>
        </div>
      </Link>
    );
  };

  return (
    <React.Fragment>
      <div styleName="entity-container" ref={componentRef}>
        <div styleName="heading">Fortune India Rankings</div>
        <div styleName="entity-list">
          <Carousel itemWidth={215} gap={deviceType === "desktop" ? 16 : 12} showDots={true} showButtons={true}>
            {options?.map((entity, index) => entityCard(entity, index))}
          </Carousel>
        </div>
      </div>
      {!isAdfreePage && (
        <BrowserView>
          <DfpComponent
            adStyleName="ad-slot-size-728x90-320x50"
            id="fortune-india-ranking-leaderboard"
            path={`/${networkId}/RPSG_Fortune_Desktop/RPSG_FRTN_HOM_Leaderboard_2`}
            adSlotConfigName="leaderboard_ad"
            showText={true}
          />
        </BrowserView>
      )}
    </React.Fragment>
  );
};

RankingEntities.propTypes = {
  data: object,
};

export default RankingEntities;
